// extracted by css-extract-rspack-plugin
export default {"surveyIntro":"surveyIntro-3Nb8M","surveyDescription":"surveyDescription-1HQw2","logoContainer":"logoContainer-2HI9N","logo":"logo-2uWQ8"};